module.exports = __webpack_public_path__ + "static/media/footrise-15.edfa0c8c.png";